import React, { type ComponentType } from "react";

import type { SvgIconProps } from "veneer/SvgIcon";
import { Colors } from "veneer/Theme";
import Tooltip from "veneer/Tooltip";

import {
  DEVICE_HIBERNATING,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
  DEVICE_SHELL,
} from "cortex/ui/src/constant/deviceStatus";
import { Device } from "cortex/ui/src/fleet/view/device/model";
import { getStatus } from "cortex/ui/src/redux-store/devices/selectors";

interface DeviceStatusIconProps {
  device: Device;
}

export function DeviceStatusIcon({ device }: DeviceStatusIconProps) {
  const deviceStatus = getStatus(device);
  const { icon, label } = deviceStatus;
  const Icon = icon as ComponentType<SvgIconProps> | undefined;

  if (!Icon) {
    return null;
  }

  return (
    <Tooltip title={label}>
      {label === DEVICE_ONLINE.label && <Icon color="success" />}
      {label === DEVICE_OFFLINE.label && <Icon htmlColor={Colors.gray700} />}
      {label === DEVICE_HIBERNATING.label && (
        <Icon htmlColor={Colors.gray700} />
      )}
      {label === DEVICE_SHELL.label && <Icon htmlColor={Colors.gray700} />}
    </Tooltip>
  );
}
